import React from "react";
import { CURRENT_YEAR } from "../../configs/AppConfig";

const Footer = () => {
    return (
        <footer className="bg-dark text-center text-white">
            <div className="text-center p-3 footer_text">
                Copyright {CURRENT_YEAR} @ <span className="text-white">DocuSafe.ai</span> All rights reserved
                <br />
                <span style={{ fontWeight: 'bold', background: '#f8f9fa', color: '#212529', padding: '4px 10px', borderRadius: '6px', display: 'inline-block', marginTop: '8px' }}>
                    Made with <span role="img" aria-label="bulb">💡</span> by alumni of
                    <a href="https://www.iima.ac.in/" target="_blank" rel="noopener noreferrer" style={{ color: '#1a237e', textDecoration: 'none', fontWeight: 'bold', margin: '0 4px' }}>IIM Ahmedabad</a>
                    and
                    <a href="https://www.bits-pilani.ac.in/" target="_blank" rel="noopener noreferrer" style={{ color: '#1a237e', textDecoration: 'none', fontWeight: 'bold', margin: '0 4px' }}>BITS Pilani</a>
                </span>
            </div>
        </footer>
    );
};

export default Footer;
